import React, { useRef, useEffect, useState } from "react";
import Modal from "react-modal";
import icon1 from "../Assets/img/cal_icon.png";
import icon2 from "../Assets/img/razorpay.png";
import icon3 from "../Assets/img/shield.png";
import dp from "../Assets/img/Ellipse.png";
import styles from "../Assets/css/NewCoupons.module.css";
import { style } from "dom-helpers";
import { BASE_URL } from "../env";
import displayRazorpay from "../Razorpay";

Modal.setAppElement("#root");

function NewCoupons(props) {
	//   console.log("props from New Coupon", props);
	const [modal, setModal] = useState(false);

	console.log("Modal Value", modal);
	console.log("props from newcoupon", props);

	const [apply, setApply] = useState(false);
	const [name, setName] = useState(false);
	const [Id, setId] = useState(false);

	const setData = props.setData;
	const setCoupon = props.setCoupon;
	const tierId = props.tierId;
	const setCouponCode = props.setCouponCode;

	const token = props.token;
	const setLoadT1 = props.setLoadT1;
	const setLoadT2 = props.setLoadT1;
	const setLoadT3 = props.setLoadT1;
	const handlePaymentPopup = props.handlePaymentPopup;
	const startAmount = props.amount;
	const setHandlePayment = props.setHandlePayment;

	const [couponApplied, setCouponApplied] = useState(false);

	let [amount, setAmount] = useState(startAmount);
	let [discountCount, setDiscountCount] = useState(0);

	let [applied, setApplied] = useState("Apply");
	let [msgApply, setMsgApply] = useState("Apply");
	const code = useRef(null);
	const [handleOrder, setHandleOrder] = useState(false);

	const [loader, setLoader] = useState(false);

	function couponValidate(event) {
		event.preventDefault();

		let coupon_code = code.current.value;

		if (coupon_code != "") {
			fetch(BASE_URL + "/getAllCoupons")
				.then((response) => response.json())
				.then((data) => {
					const coupons = data.coupons;
					const initialAmount = startAmount;
					for (let coupon of coupons) {
						if (
							coupon_code == coupon.couponCode &&
							coupon.numAllowed > 0
						) {
							let discount = coupon.percentage;
							// amount = ;
							// amount = Math.ceil(amount);
							// discountCount = discountCount + 1;
							setDiscountCount(discountCount + 1);
							setAmount(
								Math.ceil(
									initialAmount -
										(initialAmount * discount) / 100
								)
							);

							setMsgApply("Applied");

							setCouponApplied(true);
						} else if (coupon_code != coupon.couponCode) {
							setAmount(startAmount);

							setMsgApply("Not Valid");
						}
					}
				});
		} else {
			setAmount(startAmount);
			setApplied("Apply");
		}
	}

	function handlePay(event) {
		event.preventDefault();
		setLoader(true);

		let coupon_code;
		if (apply == false) {
			coupon_code = "";
		} else {
			if (code.current.value != "") {
				coupon_code = code.current.value;
			} else {
				coupon_code = "";
			}
		}

		//

		// check =

		// displayRazorpay(
		//   tierId,
		//   coupon_code,
		//   token,
		//   setLoadT1,
		//   setLoadT2,
		//   setLoadT3,
		//   setCoupon,
		//   handlePaymentPopup,
		//   setData,
		//   setHandlePayment
		// );

		displayRazorpay(
			tierId,
			coupon_code,
			token,
			setLoadT1,
			setLoadT2,
			setLoadT3,
			setCoupon,
			setHandlePayment,
			setHandleOrder
			// handlePaymentPopup
		).then((data) => {
			setData(data);
		});

		setCouponCode(coupon_code);
		// async function fetchData() {
		//   let data = JSON.stringify(check);
		//   data = JSON.parse(data);
		//   return data;
		// }

		// setData(check);
		//
		//

		// .then((response) => response.json())
		// .then((data) => {
		//
		// });

		//
		props.onClose();
	}

	const closeOnEscapeKeyDown = (e) => {
		if ((e.charCode || e.keyCode) === 27) {
			props.onClose();
		}
	};

	useEffect(() => {
		fetch(BASE_URL + "/getProfile", {
			headers: {
				authorization: "Bearer " + localStorage.getItem("token"),
			},
		})
			.then((res) => res.json())
			.then((data) => {
				setId(data.user._id);
				setName(data.user.firstName + " " + data.user.lastName);
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	useEffect(() => {
		document.body.addEventListener("keydown", closeOnEscapeKeyDown);
		return function cleanup() {
			document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
		};
	}, []);

	return (
		<div>
			{/* <button onClick={()=>setModal(true)}>open it</button> */}
			<Modal
				in={props.show}
				unmountOnExit
				timeout={{ enter: 0, exit: 300 }}
				isOpen={props.show}
				onRequestClose={() => setModal(false)}
				style={{
					overlay: {
						backgroundColor: "grey",
					},
					content: {},
				}}
			>
				<form
					onSubmit={(e) => {
						handlePay(e);
					}}
				>
					<div className={styles.modal_div}>
						{/* <button style={{marginLeft:"60px"}} onClick={()=>setModal(false)}>Close it</button> */}
						<p className={styles.cyo}>Confirm your order</p>
						<div className="row">
							<div className="col-3">
								<img
									src={dp}
									style={{ width: "50px", height: "50px" }}
								/>
							</div>
							<div className="col-8">
								<b style={{ fontSize: "20px" }}>{name}</b>
								<br />
								{Id}
							</div>
							<hr className={styles.NewCoupons_hr} />
						</div>

						<div className="row">
							<div className={" col-8 " + styles.fastTrack}>
								Fast Track
							</div>
							<div className={" col-4 " + styles.original_price}>
								Rs 11999
							</div>
						</div>

						<div className="row">
							<div className={" col-8 " + styles.end_txt}>
								<p>
									Course begins by{" "}
									<span style={{ color: "red" }}>
										25th June
									</span>{" "}
								</p>
							</div>
							<div
								className={" col-4 " + styles.disc_price}
								style={{ marginTop: "-10px" }}
							>
								Rs 9,999/-
							</div>
						</div>

						<p
							onClick={() => setApply(!apply)}
							className={styles.acc}
						>
							Apply coupon code
						</p>
						{apply && (
							// <input
							//     type="text"
							//     placeholder="Coupon Code"
							//     style={{textAlign:"center",marginLeft:"20%",borderRadius:"10px"}}
							//     height="20px"
							//     width="400px" />

							<div class={`${styles.formgroup} d-flex`}>
								<input
									type="text"
									class={styles.formcontrol}
									id="coupon-code"
									placeholder="Apply Coupon Code"
									name="coupon-code"
									ref={code}
									// value="Not Applied"
									style={{ height: "8px" }}
								/>
								<h6
									onClick={() => {}}
									class={styles.cancellink}
								>
									<h6
										onClick={(e) => {
											couponValidate(e);
											// setMsgApply(true);
										}}
										style={{ marginTop: "0" }}
										class="cancel-link"
									>
										{msgApply}
									</h6>
									{/*  */}
									{/* {msgApply ? (
    amount != startAmount ? (
      <h6>✅ Applied</h6>
    ) : (
      <h6> Invalid</h6>
    )
  ) : null} */}
								</h6>
							</div>
						)}

						{apply && (
							<div class={styles.appliedlink}>
								<h6
									onClick={() => {
										setApply(false);
										setMsgApply("Apply");
										setAmount(startAmount);
									}}
								>
									Close
								</h6>
							</div>
						)}

						<div className="row">
							<hr className={styles.NewCoupons_hr} />
						</div>

						<h2 className={styles.cpn_ttl}>Total</h2>

						<div className="row">
							<div className={" col-7 " + styles.end_txt}>
								Price inclusive of 18% GST
							</div>
							<div
								className={" col-5 " + styles.disc_price}
								style={{ fontSize: "25px", marginTop: "-10px" }}
							>
								{couponApplied === false ? (
									<b>{props.amount}/-</b>
								) : (
									<b>{amount}/-</b>
								)}
								{/* Rs 9,999 */}
							</div>
						</div>

						<button
							type="submit"
							className={styles.proceed_btn}
							onClick={() => {}}
						>
							Proceed to pay
						</button>
						<br />

						{/* <img src={icon1} />
                <p className={ " col-5 "  + styles.end_txt}>7 day Money back Guarantee</p> */}
						<div className="row">
							<div className="col-4">
								<img src={icon1} />
								<p className={styles.end_txt}>
									7 day Money back Guarantee
								</p>
							</div>
							<div className="col-4">
								<img src={icon2} />
								<p className={styles.end_txt}>
									Powered byRazorPay
								</p>
							</div>
							<div className="col-4">
								<img src={icon3} />
								<p className={styles.end_txt}>
									{" "}
									100% Safe &Secure Payment
								</p>
							</div>
						</div>
					</div>
				</form>
			</Modal>
		</div>
	);
}

export default NewCoupons;
